export default __webpack_public_path__ + "static/media/memora_1r3c.e28b6cea.png";